import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Brand,
  BrandWrapper,
  ExpandIcon,
  NavIcon,
  NavPart,
  NavStyle,
  NavSubLink,
  NavSubStyle,
  NavSubTitle,
  NavTitle,
  NavWrapper,
} from "./style";
import Logo from "../../assets/svgs/logo";
import {
  TbDeviceDesktopAnalytics,
  TbPlus,
  TbMinus,
  TbUser,
  TbReportMoney,
  TbReceiptRupee,
  TbCalendarTime,
  TbLogout,
  TbMoneybag,
  TbCashBanknote,
  TbNotes,
  TbReceiptTax,
  TbPigMoney,
} from "react-icons/tb";
import { theme } from "../../theme";
import Ripple from "../../ppui/ripple";
import { MdOutlineHolidayVillage } from "react-icons/md";
const isActiveGroup = (location, paths) => {
  return paths.some((path) => location.pathname.startsWith(path));
};

const NavItem = ({ title, icon, to, links = [], isNavActive }) => {
  const location = useLocation();
  const paths = links.map((link) => link.to);
  const parentIsActive = isActiveGroup(location, paths);

  const [isExpanded, setIsExpanded] = useState(parentIsActive);
  const [height, setHeight] = useState("0");
  const contentRef = useRef(null);

  const toggleExpanded = () => {
    if (contentRef.current) {
      setIsExpanded(!isExpanded);
      setHeight(
        isExpanded ? "0" : `${contentRef.current.scrollHeight / 16}rem`
      );
    }
  };

  useEffect(() => {
    if (parentIsActive && contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
      setIsExpanded(true);
    }
    if (isNavActive === true && contentRef.current) {
      setHeight(`0`);
      setIsExpanded(false);
    }
  }, [parentIsActive, isNavActive]);

  return (
    <li className={isExpanded ? "active" : ""}>
      <>
        <NavTitle
          component={links.length > 0 && "div"}
          aria-expanded={isExpanded}
          onClick={() => {
            if (links.length > 0) {
              toggleExpanded();
            }
          }}
          to={to}
          className={parentIsActive ? "active" : ""}
        >
          <NavIcon>{icon}</NavIcon>
          {!isNavActive && (
            <>
              {title}
              {links.length > 0 && (
                <ExpandIcon>{isExpanded ? <TbMinus /> : <TbPlus />}</ExpandIcon>
              )}
            </>
          )}
          <Ripple color={theme.colors.default.main} duration={1000} />
        </NavTitle>
        {links.length > 0 && (
          <NavSubStyle
            ref={contentRef}
            sx={{
              maxHeight: height,
            }}
            className={isNavActive && "collapseNav"}
          >
            {isNavActive && <NavSubTitle>{title}</NavSubTitle>}
            <ul>
              {links.map((link) => (
                <li key={link.to}>
                  <NavSubLink to={link.to}>{link.label}</NavSubLink>
                </li>
              ))}
            </ul>
          </NavSubStyle>
        )}
      </>
    </li>
  );
};

function EmployeePortalNav({ isNavActive }) {
  return (
    <>
      <NavWrapper className={isNavActive ? "navCollapse" : ""}>
        <BrandWrapper>
          <Brand to={"/"}>
            <Logo />
          </Brand>
        </BrandWrapper>
        <NavPart className={isNavActive ? "navCollapse" : ""}>
          <NavStyle>
            <NavItem
              icon={<TbDeviceDesktopAnalytics />}
              title="Dashboard"
              to="/employee-portal"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbUser />}
              title="My Profile"
              to="my-profile"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbReportMoney />}
              title="Salary Structure"
              to="salary-structure"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbReceiptRupee />}
              title="Payslips"
              to="payslips"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbCalendarTime />}
              title="Attendance"
              to="/"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbLogout />}
              title="Leave"
              to="leave"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<MdOutlineHolidayVillage />}
              title="Holiday"
              to="holiday"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbMoneybag />}
              title="Apply Loan"
              to="apply-loan"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbCashBanknote />}
              title="Reimbursement"
              to="/"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbNotes />}
              title="KYC"
              to="/"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbReceiptTax />}
              title="ESI & EPF"
              to="/"
              isNavActive={isNavActive}
            />

            <NavItem
              icon={<TbPigMoney />}
              title="Tax Saving "
              to="/"
              isNavActive={isNavActive}
            />
          </NavStyle>
        </NavPart>
      </NavWrapper>
    </>
  );
}

export default EmployeePortalNav;
